import { useEffect } from 'react';
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Form, FormGroup, Label, Input, Button, FormText, Row, Col
} from 'reactstrap';

const AddEditApproverModal = ({
  mode,
  open,
  onClose,
  formik,
  user
}) => {
  const isAddMode = mode === 'add';
  const isEditMode = mode === 'edit';

  useEffect(() => {
    const companyId = user?.companyId || user?.company_id || user?.id;
    if (companyId) {
      formik.setFieldValue('company_id', companyId);
    }
  }, [user]);

  const getFieldValue = (field, defaultValue = '') => {
    return formik.values[field] ?? defaultValue;
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    formik.setFieldValue(name, value);
  };

  const getFieldError = (field) => {
    return formik.touched[field] && formik.errors[field] ? formik.errors[field] : null;
  };

  const handleFieldBlur = (e) => {
    const { name } = e.target;
    formik.setFieldTouched(name, true);
  };

  return (
    <Modal isOpen={open} toggle={onClose} size="lg">
      <Form onSubmit={formik.handleSubmit}>
        <ModalHeader toggle={onClose}>
          {isEditMode ? 'Edit Approver' : 'Add Approver'}
        </ModalHeader>

        <ModalBody>
          <Row className="mb-3">
            <Col md={6}>
              <FormGroup>
                <Label for="name" style={{ fontSize: '0.875rem' }}>Name *</Label>
                <Input
                  id="name"
                  name="name"
                  type="text"
                  value={getFieldValue('name')}
                  onChange={handleFieldChange}
                  onBlur={handleFieldBlur}
                  disabled={formik.isSubmitting}
                  invalid={!!getFieldError('name')}
                  required
                />
                {getFieldError('name') && (
                  <FormText color="danger">{getFieldError('name')}</FormText>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="email" style={{ fontSize: '0.875rem' }}>Email *</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  value={getFieldValue('email')}
                  onChange={handleFieldChange}
                  onBlur={handleFieldBlur}
                  disabled={formik.isSubmitting}
                  invalid={!!getFieldError('email')}
                  required
                />
                {getFieldError('email') && (
                  <FormText color="danger">{getFieldError('email')}</FormText>
                )}
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>

        <ModalFooter>
          <Button
            type="submit"
            color="primary"
            disabled={formik.isSubmitting || !user?.id}
          >
            {isEditMode ? 'Update' : 'Save'}
          </Button>
          <Button
            type="button"
            color="secondary"
            onClick={onClose}
            disabled={formik.isSubmitting}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export { AddEditApproverModal };